import React from 'react'

function RecomendedTopic({ cateogary }) {
    return (
        <a href={`/cateogary/${cateogary}`} className="topics-list mt-3">
            <div className="list1">
                <span className="fa fa-bath" />
                <h4>{cateogary.charAt(0).toUpperCase() + cateogary.slice(1)}</h4>
            </div>
        </a>
    )
}

export default RecomendedTopic
